import React from "react";
import { Helmet } from "react-helmet";

import Header from "../../components/Header";
import WelcomeImage from "../../components/WelcomeImage";
import ImageText1 from "../../components/ImageText1";
import ImageText2 from "../../components/ImageText2";
import Footer from "../../components/Footer";

import backgroundImage from "../../assets/images/inkoopenlogistiek/bg-inkoop.jpg";
import imageUrl from "../../assets/images/inkoopenlogistiek/inkoop-section1.jpg";
import imageUrl2 from "../../assets/images/inkoopenlogistiek/inkoop-section2.jpg";

function InkoopenLogistiek() {
  const welcomeHeading = "Inkoop en Logistiek";

  const imageTextText = (
    <>
      Inkoop en Logistiek zijn complementaire functies binnen een organisatie
      die samen zorgen voor een efficiënte toeleveringsketen. Inkoop richt zich
      op het verwerven van de benodigde goederen en diensten voor de gevraagde
      kwaliteit tegen de beste prijs en voorwaarden. <br />
      Logistiek is een essentieel onderdeel van iedere bedrijfsvoering, van een
      kleine winkel tot een grote multinational. Het gaat om het efficiënt en
      kosteneffectief verplaatsen en opslaan van goederen, maar ook om het
      beheren van de informatie en de diensten die nodig zijn om de logistieke
      processen te ondersteunen.
    </>
  );

  const imageTextText2 = (
    <>
      DD-Group beschikt over ruime expertise op het gebied van inkoop en
      logistiek om u hierover gedegen te kunnen adviseren, zodat dit efficiency
      en kostenbesparing oplevert. <br />
      Hiertoe wordt ook gebruik gemaakt van een Quickscan (0-meting), waarbij
      aangegeven wordt wat er op dit gebied mogelijk is. Wij kunnen met u
      sparren en meedenken over hoe het inkoop- en logistieke proces
      geoptimaliseerd kan worden.
    </>
  );

  return (
    <div>
      <Helmet>
        <title>Inkoop en Logistiek</title>
        <meta
          name="description"
          content="Heb je vakbekwame professionals nodig voor korte of lange termijn rollen? Ons duidelijke en flexibele wervingsproces helpt je de juiste kandidaat te vinden, of ze nu recent afgestudeerd zijn of ervaren specialisten."
        />
      </Helmet>
      <header>
        <Header />
      </header>
      <main>
        <WelcomeImage
          backgroundImage={backgroundImage}
          heading={welcomeHeading}
        />
        <section>
          <ImageText1 imageUrl={imageUrl} text={imageTextText} />
          <ImageText2
            imageUrl={imageUrl2}
            text={imageTextText2}
            backgroundColor="#D9D9D9"
            textColor="black"
          />
        </section>
      </main>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default InkoopenLogistiek;
